import { gsap } from 'gsap';

import './accordion.scss';

export class Accordion {

	wrapper: HTMLElement;

	constructor(wrapper: HTMLElement) {
		this.wrapper = wrapper;

		this.wrapper.querySelectorAll('.accordion-title').forEach( (header: HTMLElement) => {
			header.addEventListener('click', (ev: MouseEvent) => {
				ev.preventDefault();

				if ( header.closest('li').classList.contains('active') ) {
					header.closest('li').classList.remove('active');

					gsap.to(header.closest('li').querySelector('.accordion-content'), {
						height: 0,
						duration: .7,
						ease: 'linear'
					});

				} else {
					header.closest('li').classList.add('active');

					gsap.to(header.closest('li').querySelector('.accordion-content'), {
						height: 'auto',
						duration: .7,
						ease: 'linear'
					});

					header.scrollIntoView({ behavior: 'smooth' });
				}
			});
		});
	}

}